import React from 'react'
import { connect } from 'react-redux'
import { changeQuestion, deleteQuestion, saveQuestion } from '../../actioncreators/actioncreators'
import swal from 'sweetalert'
import truncate from 'truncate'
const { Component } = React

const preventPropagation = (e) => {
  e.stopPropagation()
}

export class Question extends Component {
  constructor (props, context) {
    super(props, context)

    this.state = {
      hover: false
    }

    this.questionInput = React.createRef()
  }

  componentDidMount () {
    if (this.props.allowAutofocus) {
      this.questionInput.current.focus()
    }
  }

  render () {
    return (
      <div onDoubleClick={preventPropagation}>
        <div
          style={{
            minWidth: 290,
            maxWidth: 290,
            marginRight: 5
          }}
        >
          <div
            style={{
              height: 14,
              marginLeft: 3,
              marginRight: 3,
              color: 'white',
              backgroundColor: '#FF3B26',
              fontSize: 10
            }}
          >
            <span
              style={{
                marginLeft: 5
              }}
            >Question</span>
          </div>
          <div className='panel panel-default' style={{ marginLeft: 3, marginRight: 3, border: 'none' }}>
            <div className='panel-body' style={{ padding: '7px 4px', backgroundColor: '#ABAAAA' }}
              onMouseEnter={() => this.setState({ hover: true })}
              onMouseLeave={() => this.setState({ hover: false })}>
              <button className={this.state.hover ? 'btn btn-default btn-xs' : 'hidden btn btn-default btn-xs'}
                style={{ position: 'absolute', marginTop: -15, marginLeft: 254, zIndex: '100' }}
                onClick={this.props.deleteQuestion}
                title='Delete question'>
                <span className='glyphicon glyphicon-trash' aria-hidden='true' />
              </button>
              <textarea
                className='form-control'
                rows='4'
                value={this.props.text}
                onChange={this.props.onQuestionChange}
                onBlur={this.props.saveQuestion}
                placeholder='Capture a question / answer '
                style={{ resize: 'vertical' }}
                ref={this.questionInput}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = function (store, ownProps) {
  return {
    text: ownProps.question.text,
    allowAutofocus: store.exampleMap.allowAutofocus
  }
}

const mapDispatchToProps = function (dispatch, ownProps) {
  return {
    onQuestionChange: (event) => dispatch(changeQuestion(ownProps.question.id, event.target.value)),
    deleteQuestion: () => {
      swal({
        title: 'Delete this question?',
        text: `Click OK to delete "${truncate(ownProps.question.text, 30)}"` ,
        icon: 'warning',
        buttons: true
      })
        .then((willDelete) => {
          if (willDelete) {
            dispatch(deleteQuestion(ownProps.question.id))
          }
        })
    },
    saveQuestion: (event) => dispatch(saveQuestion(ownProps.question.id, event.target.value))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Question)
